import React from 'react'
import Linkedinimage from "./linkedin.png"

export default function Linkedin() {
  return (
    <img src={Linkedinimage} width="20px" height="20px"></img>
  )
}
